export default __webpack_public_path__ + "static/media/iconmissed.9c368839.svg";